module.exports = __webpack_public_path__ + "img/GALLERY-SWIFT-SPORT-1.9db17ddc.jpg";